import moment from 'moment';
import { contractPlanStop, contractInfo } from './request';
export default {
  data() {
    return {
      dataFrom: {
        reason: '',
        stopAt: ''
      },
      dialogVisible: false
      // pickerOptions: {
      //   selectableRange: (() => {
      //     let data = new Date();
      //     let hour = data.getHours();
      //     let minute = data.getMinutes();
      //     let second = data.getSeconds();
      //     return [`${hour}:${minute}:${second} - 23:59:59`];
      //   })(),
      //   disabledDate(time) {
      //     var date = new Date();
      //     date.setFullYear(date.getFullYear() + 2);
      //     date.setDate(date.getDate() - 1);
      //     return time.getTime() < Date.now() - 8.64e7 || time.getTime() > date.getTime();
      //   }
      // }
    };
  },
  computed: {
    dataRule() {
      return {
        reason: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('中止原因')
        }],
        stopAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('中止时间')
        }]
      };
    }
  },
  methods: {
    disabledDate(current) {
      return current < moment().subtract(1, 'days') || moment().add(2, 'years').subtract(1, 'days') < current;
    },
    init(val) {
      contractInfo({
        contractId: val.contractId
      }).then(res => {
        this.dataFrom.reason = res.reason || '';
        this.dataFrom.stopAt = res.stopAt || '';
      });
      this.dataFrom.contractId = val.contractId;
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          console.log(this.dataFrom);
          contractPlanStop(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok');
            this.$emit('cancel');
          });
        }
      });
    }
  }
};